import { codeLangConfig2, CODE_LANG_KEY } from '../lang'

function generateCodeWs(api, codeLang, host, defaultCode) {
  const code = codeLangConfig2.find(item => item.value === codeLang)
  if (!code) {
    return defaultCode || 'No Code'
  }


  let codeStr = require("@/utils/codeWs/" + codeLang + '.js').default
  if( api && api.uri)
    codeStr = codeStr.replace(/AAPPII/g, api.uri)

  const url = window.location.href;
  if (url.indexOf('/spot/') > -1  ) {
    codeStr = require("@/utils/codeWs/spot/" + codeLang + '.js').default
    if( api && api.uri)
      codeStr = codeStr.replace(/AAPPII/g, api.uri)
    if (url.indexOf('/account') > -1) {
      codeStr = codeStr.replace(/HHOOSSTT/g, "wss://open-api-ws.bingx.com/market?listenKey=a8ea75681542e66f1a50a1616dd06ed77dab61baa0c296bca03a9b13ee5f2dd7")
    } else {
     codeStr = codeStr.replace(/HHOOSSTT/g, "wss://open-api-ws.bingx.com/market")
    }
  } else if (url.indexOf('/cswap/') > - 1) {
    codeStr = require("@/utils/codeWs/cswap/" + codeLang + '.js').default
    if( api && api.uri)
      codeStr = codeStr.replace(/AAPPII/g, api.uri)
    if (url.indexOf('/account') > -1) {
      codeStr = codeStr.replace(/HHOOSSTT/g, "wss://open-api-cswap-ws.bingx.com/market?listenKey=a8ea75681542e66f1a50a1616dd06ed77dab61baa0c296bca03a9b13ee5f2dd7")
    } else {
      codeStr = codeStr.replace(/HHOOSSTT/g, "wss://open-api-cswap-ws.bingx.com/market")
    }
  }
  else {
    if (url.indexOf('/account') > -1) {
      codeStr = codeStr.replace(/HHOOSSTT/g, "wss://open-api-swap.bingx.com/swap-market?listenKey=a8ea75681542e66f1a50a1616dd06ed77dab61baa0c296bca03a9b13ee5f2dd7")
    }else {
      codeStr = codeStr.replace(/HHOOSSTT/g, "wss://open-api-swap.bingx.com/swap-market")
    }
  }

  return codeStr

}

export default generateCodeWs



// WEBPACK FOOTER //
// ./src/utils/codeWs/generate.js